import type { FaireProductEntity } from "../../entity_types/product";

export const p_mycnuu3ymp: FaireProductEntity = {
  token: "p_mycnuu3ymp",
  type: "product",
  name: "Tribal Soul Palo Santo Incense Smudge sticks 15 grams(pack of 12)",
  brandToken: "b_pfe5z89pnk",
  brandName: "Vrinda",
  imageUrl:
    "https://cdn.faire.com/fastly/bfbcd7f7ee248db3474e869a8d0e01b3df00d788e495d942a9aca0086f9906de.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/549dd52f3db0b24f595cb58ff9d076b029dd7c11df9a4c8ba3b4c4a786da0e1d.jpeg",
  ],
  priceDollars: 13.84,
  description:
    "Enjoy the calming aroma of Vrinda's Palo Santo Incense Smudge Sticks. Each pack contains 12 masala incense sticks from the Hari Darshan brand. Ideal for those seeking balance, peace, and spiritual connection, these incense sticks are a welcome addition to any home fragrance collection. As a family-owned business established in 2008, Vrinda is dedicated to supporting mindfulness and sacred living through our thoughtfully crafted products.",
  tags: [],
  msrpDollars: 27.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:19.388Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
